export default __webpack_public_path__ + "static/media/KM.d36ddb68.svg";